<template>
    <div>
        <CircleButton v-if="showHomeButton !== false" class="home" big="false" :icon="home_icon" @circleBtnClick="navigateToWaitScreen()"></CircleButton>
        <CircleButton v-if="showBackButton" class="home" big="false" :icon="back_icon" @circleBtnClick="navigateToBackScreen()"></CircleButton>
        <img :src="getImage() || header">
        <CircleButton v-if="showButton()" class="cart" big="false" :icon="cart_icon" @circleBtnClick="navigateToCartScreen()"></CircleButton>
    </div>
</template>

<script>
import CircleButton from '@/components/CircleButton'
import CartController from '@/assets/controllers/CartController'
import Util from '@/assets/libs/util'

export default {
    name: 'Header',
    props: ['showCartButton', 'showHomeButton', 'showBackButton'],
    components: {
        CircleButton
    },
    data () {
        return {
            header: require('../../static/client/header.png'),
            home_icon: require('../../static/icons/home.png'),
            cart_icon: require('../../static/icons/cart.png'),
            back_icon: require('../../static/icons/arrow_back_white.svg')
        }
    },
    methods: {
        getImage: function () {
            return Util.getConfigImage('logo')
        },
        showButton: function () {
            return this.showCartButton && !CartController.isCartEmpty()
        },
        navigateToWaitScreen: function () {
            if (this.$router.currentRoute.name === 'Home') {
                if (CartController.isCartEmpty()) {
                    CartController.resetCart()
                    this.$router.push('/')
                } else {
                    CartController.clearCart(this, '/')
                }
            } else {
                if (Util.isBalancaMode() && !Util.isHybridMode()) {
                    this.$router.push('/')
                } else {
                    this.$router.push('Home')
                }
            }
        },
        navigateToCartScreen: function () {
            let isCartEmpty = CartController.isCartEmpty()
            if (!isCartEmpty) {
                this.$router.push('/checkout')
            }
        },
        navigateToBackScreen: function () {
            this.$emit('navigateToBackScreen')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");
    .header{
        background: @header-color;
        position: relative;
        height: 180px;
    }
    img {
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        position: relative;
        display: block;
        height: 150px;
        padding: 10px 0;
    }
    .btn-big {
        position: absolute;
        top: calc(50% - 36px);
        &.home{
            left: 5%;
        }
        &.cart{
            right: 5%;
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .header{
            height: 50px;
        }
        .btn-big {
            top: calc(50% - 17px);
        }
        img {
            height: 30px;
            padding: 0;
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
       .header{
            height: 130px;
        }
        img {
            height: 90px;
            padding: 10px 0;
        }
    }

    @media (orientation: landscape) {
        .header{
            height: 90px;
        }
        img {
            transform: translate(-50%, -50%);
            left: 50%;
            top: 50%;
            position: relative;
            display: block;
            height: 70px;
            padding: 10px 0;
        }
        .btn-big {
            position: absolute;
            top: calc(50% - 36px);
            &.home{
                left: 5%;
            }
            &.cart{
                right: 5%;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue